module.exports = __webpack_public_path__ + "img/mp4.a9c00c18.jpg";